import React, { Component } from 'react';

import ReactCSSTransitionGroup from 'react-addons-css-transition-group';

import { connect } from 'react-redux';
import { openDrawer, closeDrawer } from 'actions/drawer';
import { openModal } from 'actions/modal';
import { addNotification } from 'actions/notifications';

import { firebaseConnect, helpers } from 'react-redux-firebase';
const { isLoaded, dataToJS, pathToJS, populatedDataToJS } = helpers;

import OrderList from 'components/OrderList';
import ContentHeader from 'components/ContentHeader';
import Button from 'components/Button';
import Input from 'components/Input';
import Footer from 'components/AppFooter/AppFooter';

import Loader from 'components/Loader/Loader';

import { arrToKeyedObj, keyedObjToArr } from '../../util';

import OrderPanel from 'components/OrderPanel';

import { Order } from 'models';
import { validateOrder } from 'models/validate';

class Orders extends Component {

	constructor (props) {
		super(props);

        this.state = {
            filterBy: ''
        };
	}

	createOrder () {
		let order = {};
		this.props.openDrawer(<OrderPanel
			order={order}
			addOrder={this.addOrder.bind(this)}
		/>);
	}

	editOrder (order) {
		this.props.openDrawer(<OrderPanel
			order={order}
			editing={true}
			saveOrder={this.saveOrder.bind(this)}
		/>);
	}

	updateCustomerOrders (order, newOrderId) {
		const { firebase } = this.props;
		let orderId = newOrderId || order.id;
		if(order.customer) {
			let customerOrderIds = this.props.customers[order.customer].orders || {};
			customerOrderIds[orderId] = true;
			firebase.set(`/customers/${order.customer}/orders`,customerOrderIds);
		} else {
			//TODO remove orderId from existing customers
		}
	}

	addOrder (order) {

		order.products = arrToKeyedObj(order.products);

		const { firebase } = this.props;
		firebase.push('/orders', order).then( (response) => {
			this.updateCustomerOrders(order, response.key);
		}).catch( (err) => {
			console.log(err);
		});
	}

	saveOrder (order) {
		order.products= arrToKeyedObj(order.products);
		const { firebase } = this.props;
		console.log('save order');
		console.log(order);

		firebase.set(`/orders/${order.id}`, order).then( (response)=> {
			console.log('set order then do this');
			this.updateCustomerOrders(order, order.id);
		}).catch( (err) => {
			console.log(err);
		});
	}

	deleteOrder (order) {
		this.props.openModal(null, {
			message : 'Are you sure you want to delete this Order?',
			title : 'Delete Order',
			onClose : (result) => {
				if(result === true) {
					const { firebase } = this.props;;

					// Remove the order from the customer
					keyedObjToArr(this.props.customers).forEach( (customer)=> {
						if(customer.orders && customer.orders[order.id]){
							firebase.remove(`/customers/${customer.id}/orders/${order.id}`);
						}
					});

                    // Remove the order from the database
                    firebase.remove(`/orders/${order.id}`)
				}
			}
		});
	}

	updateDrawerState () {
		//Update the state for the drawer
	}

    filterChanged(event){
        this.setState({
            filterBy: event.target.value
        });
    }

	render () {
		if( !isLoaded(this.props.orders) ||
				!isLoaded(this.props.customers) ||
				!isLoaded(this.props.products)
		){
			return (
				<div className="main-content-area" key="customers">
					<div className="page-content">
						<div className="container">
							<Loader color="main" size="large" />
						</div>
					</div>
				</div>
			);
		}

		let button = (<Button
			label="Create Order"
			onClick={this.createOrder.bind(this)}
		/>);

        let filter = (<Input
			placeholder="Search"
			inputClass="filter-box"
			value={this.state.filterBy}
			onChange={this.filterChanged.bind(this)}
		/>)

		return (
			<ReactCSSTransitionGroup
				transitionName="main-content"
				transitionAppear={true}
				transitionAppearTimeout={1500}
				transitionEnterTimeout={1500}
				transitionLeaveTimeout={1500}
				className="main-transition-wrap"
			>
			<div className="main-content-area" key="orders">
				<ContentHeader
					title="Orders"
					filter={filter}
					button={button}
				/>
				<div className="page-content">
					<div className="container">
						<div className="row">
							<div className="col-12">
								<div className="main-list-area">
									<OrderList
										filterBy={this.state.filterBy}
										orders={this.props.orders}
										customers={this.props.customers}
										products={this.props.products}
										editOrder={this.editOrder.bind(this)}
										deleteOrder={this.deleteOrder.bind(this)}
									/>
								</div>
							</div>
						</div>
					</div>
					<Footer/>
				</div>
			</div>
			</ReactCSSTransitionGroup>
		);
	}
}

const populates = [
	{child : 'customer', root : 'customers' }
];

const mapDispatchToProps = (dispatch) => {
	return {
		openDrawer :  (id) => { dispatch(openDrawer(id)); },
		closeDrawer : () => { dispatch(closeDrawer()); },
		openModal : (modal, props) => { dispatch(openModal(modal, props)); },
		addNotification : (key, message) => { dispatch(addNotification(key, message)); }
	};
};

const fbWrappedComponent = firebaseConnect( ({auth, profile, user}) => {

	if(!profile){
		return [];
	}
	if(profile.role === 'admin') {
		return [
			'/orders',
			'/customers',
			'/products'
		];
	} else if(profile.customer) {
		return [
			{
				path: 'orders',
				storeAs: 'orders',
				queryParams: [ `orderByChild=customer`, `equalTo=${profile.customer}`]
			},
			{
				path: 'customers/'+profile.customer,
				storeAs: 'customers'
			},
			{
				path: 'products',
				storeAs: 'products'
			}
		];

	} else {
		return [];
	}
})(Orders);

const connectAuth = connect(
	({ firebase }) => {
		return{
			profile: pathToJS(firebase, 'profile'),
			authError: pathToJS(firebase, 'authError'),
			auth : pathToJS(firebase, 'auth')
		};

	}
)(fbWrappedComponent);

export default connect(
  ({ firebase }) => ({
		orders : dataToJS(firebase, 'orders'),
		customers : dataToJS(firebase, 'customers'),
		products : dataToJS(firebase, 'products')
    //ordersWithCustomers: populatedDataToJS(firebase, 'orders', populates)
  }),
  mapDispatchToProps
)(connectAuth);




// WEBPACK FOOTER //
// ./js/containers/Orders/Orders.js